import type { AxiosInstance } from 'axios';

export type ItemDualListRow = {
  id: string;
  label: string;
  ite_alternativeidentifier: string;
  its_id: string;
  ite_tag: string;
  its_description: string;
};

export async function loadSubgroupMap(api: AxiosInstance): Promise<Record<string, string>> {
  try {
    const ret = await api.get('itemsubgroup/listar');
    if (ret.data.status !== 200 || !Array.isArray(ret.data.data)) {
      return {};
    }
    const map: Record<string, string> = {};
    ret.data.data.forEach((sg: { its_id?: string | number; its_description?: string }) => {
      map[String(sg.its_id)] = sg.its_description || '';
    });
    return map;
  } catch {
    return {};
  }
}

export type SubgroupOption = { value: string; label: string };

export async function loadSubgroupOptions(api: AxiosInstance): Promise<SubgroupOption[]> {
  try {
    const ret = await api.get('itemsubgroup/listar');
    if (ret.data.status !== 200 || !Array.isArray(ret.data.data)) {
      return [];
    }
    return ret.data.data.map((sg: { its_id?: string | number; its_description?: string }) => ({
      value: String(sg.its_id),
      label: sg.its_description || '',
    }));
  } catch {
    return [];
  }
}

function rowsNeedSubgroupLookup(rows: Record<string, any>[]): boolean {
  return rows.some(
    (row) =>
      row.its_id != null &&
      row.its_id !== '' &&
      !(row.its_description && String(row.its_description).trim()),
  );
}

export function mapItemToDualListRow(
  user: Record<string, any>,
  subgroupMap: Record<string, string> = {},
): ItemDualListRow {
  const itsId = user.its_id != null && user.its_id !== '' ? String(user.its_id) : '';
  return {
    id: String(user.ite_id),
    label: user.ite_description || '',
    ite_alternativeidentifier: user.ite_alternativeidentifier || '',
    its_id: itsId,
    ite_tag: user.ite_tag || '',
    its_description: user.its_description || subgroupMap[itsId] || '',
  };
}

export async function mapItemsToDualListRows(
  api: AxiosInstance,
  rows: Record<string, any>[],
  subgroupMap?: Record<string, string>,
): Promise<ItemDualListRow[]> {
  const map =
    subgroupMap ??
    (rowsNeedSubgroupLookup(rows) ? await loadSubgroupMap(api) : {});
  return rows.map((row) => mapItemToDualListRow(row, map));
}
